<template>
  <img :src="logo" :style="small ? 'height: 20px; width: 20px; vertical-align: middle;' : ''">
</template>
<script>
import vimeoLogo from '@/assets/vimeo_icon_white_on_blue.png'
import hitoLogo from '@/assets/bluehito.png'
export default {
  props: {
    small: Boolean,
    name: String
  },
  computed: {
    logo () {
      const name = this.name || 'fid'
      switch (name) {
        case 'vimeo':
          return vimeoLogo
        case 'fid':
          return hitoLogo
        default:
          console.log('couldnt find logo for ', name)
          return null
      }
    }
  }
}
</script>
